import { define } from 'wicked-elements'
import Colcade from 'colcade'

define('[data-component~="grid"]', {
  init () {
    this.$items = [...this.element.querySelectorAll('.grid-item')]
  },
  observedAttributes: ['has-filter'],
  attributeChanged(name, oldValue, newValue) {
    this.filterItems(newValue)
  },
  connected () {
    this.colc = new Colcade(this.element, {
      columns: '.grid-col',
      items: '.grid-item'
    })
  },
  disconnected () {
    this.colc.destroy()
  },
  filterItems (filter) {
    filter = filter === 'null' ? null : filter
    if (filter) {
      this.$items.forEach($item => {
        if ($item.classList.contains(filter)) {
          $item.classList.remove('opacity-30')  
        } else {
          $item.classList.add('opacity-30')  
        }
      })
    } else {
      this.$items.forEach($item => {
        $item.classList.remove('opacity-30')
      })
    }
  }
})